import { fetchWithAuth } from "../api/client";
import { ErrorResponse, GenerateWithSaveResponse } from "../types";

export async function generateVoiceFromURLRequest(
  url: string,
  token: string
): Promise<Blob | ErrorResponse> {
  const response = await fetchWithAuth("voice/generate-from-url", {
    method: "POST",
    token,
    body: JSON.stringify({
      url: url,
      voice: "coral",
      instructions: "Habla en tono natural y amistoso",
    }),
  });
  if (!response.ok) {
    return {
      error: response.status,
      message: `Error fetching generate voice: ${response.statusText}`,
    };
  }
  return await response.blob();
}

export async function generateVoiceFromTextRequestWithSave(
  text: string,
  token: string,
  language: "es" | "ca" | "en" | "ar"
): Promise<{ blob: Blob; file: File; objectKey: string } | ErrorResponse> {
  const instructions =
    language === "es"
      ? "Habla en español con un tono natural y amistoso"
      : language === "ca"
      ? "Parla en català amb un to natural i amigable"
      : language === "en"
      ? "Speak in English with a natural and friendly tone"
      : "تحدث باللغة العربية بنبرة طبيعية وودية";

  const response = await fetchWithAuth("voice/generate-with-save", {
    method: "POST",
    token,
    body: JSON.stringify({
      text,
      voice: "coral",
      instructions,
    }),
  });

  if (!response.ok) {
    const message = `Error al generar la voz: ${response.statusText}`;
    throw new Error(message);
  }
  const data = (await response.json()) as GenerateWithSaveResponse;
  const bytes = Uint8Array.from(atob(data.file.base64), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], {
    type: data.file.contentType || "audio/mpeg",
  });
  const file = new File([blob], data.file.fileName || `voice-${language}.mp3`, {
    type: blob.type,
  });

  return { blob, file, objectKey: data.objectKey };
}

export async function generateVoiceFromTextRequest(
  text: string,
  token: string,
  language: "es" | "ca"
): Promise<Blob | ErrorResponse> {
  const instructions =
    language === "es"
      ? "Habla en español con un tono natural y amistoso"
      : "Parla en català amb un to natural i amigable";
  const response = await fetchWithAuth("voice/generate", {
    method: "POST",
    token,
    body: JSON.stringify({
      text: text,
      voice: "coral",
      instructions,
    }),
  });
  if (!response.ok) {
    return {
      error: response.status,
      message: `Error fetching generate voice: ${response.statusText}`,
    };
  }
  return await response.blob();
}
export async function uploadVoiceFile(
  file: File,
  token: string
): Promise<string | ErrorResponse> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetchWithAuth("Voice/upload", {
    method: "POST",
    token,
    body: formData,
    headers: {},
  });

  if (!response.ok) {
    return {
      error: response.status,
      message: `Error uploading voice file: ${response.statusText}`,
    };
  }

  const data = await response.json();
  return data.url;
}
